import "../styles/AdminInterface.css"
import React, { useState, useEffect } from 'react'
import BackendAPI from "../API/BackendAPI"
import IconButton from '@mui/material/IconButton';

import { useHistory } from 'react-router-dom';
import { TextField, FormControl, InputLabel, Button, Divider, Typography, TableContainer, TableHead, TableRow, Paper, TableBody, Table, TableCell, Select, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core"
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import Checkbox from '@mui/material/Checkbox';
import { green } from '@mui/material/colors';
import { FormControlLabel } from '@mui/material';

import Popup from "../components/Popup"
import Sidebar from "../components/Sidebar"
import cookie from 'react-cookies'


const AdminQuestions = () => {
  // console.log("admin")
  const history = useHistory()


  const user = cookie.load("user")
  // console.log(user)
  const handleDisconnect = () => {
    // console.log("handleDisconnect")
    cookie.save('user', "disconnected", {
      path: '/',
      maxAge: 60 * 60 * 1.5, //sec
    })
    history.push('/login');
  }


  if (user === null || user === undefined || user == "disconnected") history.push("/login");
  if (user !== null && user !== undefined && user.role !== undefined && !user.role.includes("ADMIN")) handleDisconnect()


  // const [actualiser,setActualiser]=useState(true)
  const [numJeu, setNumJeu] = useState("1 - Cupcakes Battle")

  const [popupText, setPopupText] = useState(null)

  const [questions, setQuestions] = useState(null)
  const [localQuestions, setLocalQuestions] = useState(questions);
  const [popupQuestion, setPopupQuestion] = useState(null)
  const [newQuestion, setNewQuestion] = useState(null)


  useEffect(() => {
    if (questions == null) {
      clickActualiser()
    }
    setLocalQuestions(questions)
    console.log(questions)
  }, [questions])



  useEffect(() => {
    setQuestions(null)
    setNewQuestion(null)
  }, [numJeu])


  const clickActualiser = async () => {
    // if (users == null){
    const questions = await BackendAPI.getQuestions(numJeu)
    console.log(questions.length)
    setQuestions(questions)
    // }
    // setActualiser(false)

  }

  const updateServer = async (event, field, id) => {
    event.preventDefault()
    var value = "false"
    if (field !== "actif") {
      value = event.target.value?.replace("Phrase à trou","PhraseTrou")
    }

    await BackendAPI.updateQuestion(value, field, id, numJeu)
    //  setUsers(null)
  }

  const handleClicNewQuestion = async () => {
    await BackendAPI.createQuestion(newQuestion, numJeu)
    setNewQuestion(null)
    clickActualiser()
  }

  const handleChangeQuestion = (event, field, id) => {
    // setActualiser(true)
    const newValue = event.target.value
    // Crée une nouvelle liste d'utilisateurs avec les modifications apportées
    const updatedQuestions = localQuestions.map(question =>
      question.id === id
        ? { ...question, [field]: newValue?.replace("Phrase à trou","PhraseTrou")
        }
        : question
    );

    // Met à jour l'état avec la nouvelle liste d'utilisateurs
    setLocalQuestions(updatedQuestions);
  };

  const handleChangeNewQuestion = (event, field) => {
    const newValue = event.target.value;
    const question = { ...newQuestion, [field]: newValue }
    setNewQuestion(question);
  };

  const handleKeyDown = (event, field, id) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      updateServer(event, field, id);
    }
  };

  const handleBlur = (event, field, id) => {
    updateServer(event, field, id);
  };

  const handleClicDelete = async (e, q) => {
    e.preventDefault()
    const reponse = q.reponse
    if (!e.target.checked) {
      const popupText = <Typography>
        Souhaitez-vous confirmer la suppression de la question suivante ?
        <br />
        Libellé: {q.libelle}

        {reponse != null && reponse.length > 0 ?
          <><br />
            Réponse: {reponse}
          </>
          : null}

        <br />
        {/* Niveau: {q.niveau} */}
      </Typography>
      setPopupQuestion(q)
      setPopupText(popupText)
    } else {
      await BackendAPI.updateQuestion("OUI", "actif", q.id, numJeu)
    }
    clickActualiser()
  }



  // const renderChoices=(champ,u)=>{
  //   var val=""

  //   const mode_new=!(u!==null &&u.id!=undefined)

  //   if (champ=="Campus"){
  //     const campus=["Aix-En-Provence","Angers","Bordeaux","Budapest","Luxembourg","Lyon","Malaga","Paris","Shanghai","Strasbourg"]
  //     if(u!=null){val=u.campus}

  //     if(mode_new){
  //       return(
  //         <FormControl variant="outlined" style={{width:"100%"}}  >
  //         <InputLabel >{u!==null && u.id!=undefined?null:"Campus"}</InputLabel>

  //         <Select

  //           value={val}
  //           displayEmpty
  //           label={u!==null && u.id!=undefined?null:"Campus"}
  //           onChange={(e)=>{handleChangeNewUser(e,"campus")} }
  //           >

  //           {campus.map(c => (
  //           <MenuItem key={c} value={c}  >{c}</MenuItem>
  //         ))}
  //         </Select>
  //         </FormControl>  
  //       )

  //     }else{
  //       return(
  //         // <FormControl >


  //         <Select style={{width:"100%"}} 
  //           value={val}
  //           variant="outlined"
  //           onChange={(e)=>{if(u!==null &&u.id!=undefined){handleChangeUser(e,"campus",u.id)}} }
  //           onBlur={(e)=>{if(u!==null &&u.id!=undefined){handleBlur(e,"campus",u.id)}} }
  //           >

  //           {campus.map(c => (
  //           <MenuItem style={{paddingTop:14}}key={c} value={c}  >{c}</MenuItem>
  //         ))}
  //         </Select>
  //         // </FormControl>
  //       ) 
  //     }

  //   }

  //   if (champ=="Groupe"){
  //     const groupes=["1A","2A","3A","4A","5A"]
  //     if(u!=null){val=u.groupe}

  //     if(mode_new){
  //       return(
  //         <FormControl variant="outlined" style={{width:"100%"}} >
  //         <InputLabel >{u!==null && u.id!=undefined?null:"Groupe"}</InputLabel>

  //         <Select

  //           value={val}
  //           displayEmpty
  //           label={u!==null && u.id!=undefined?null:"Groupe"}
  //           onChange={(e)=>{handleChangeNewUser(e,"groupe")} }
  //           >

  //           {groupes.map(c => (
  //           <MenuItem key={c} value={c}  >{c}</MenuItem>
  //         ))}
  //         </Select>
  //         </FormControl>  
  //       )

  //     }else{
  //       return(
  //         // <FormControl >


  //         <Select
  //           value={val}
  //           variant="outlined"
  //           onChange={(e)=>{if(u!==null &&u.id!=undefined){handleChangeUser(e,"groupe",u.id)}} }
  //           onBlur={(e)=>{if(u!==null &&u.id!=undefined){handleBlur(e,"groupe",u.id)}} }
  //           >

  //           {groupes.map(c => (
  //           <MenuItem style={{paddingTop:14}}key={c} value={c}  >{c}</MenuItem>
  //         ))}
  //         </Select>
  //         // </FormControl>
  //       ) 
  //     }
  //   }
  // }

  const renderQuestions = () => {
    if (localQuestions !== null) {

      if (numJeu.includes("1 -")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader aria-label="customized table">
              <TableHead>
                <TableRow >

                  <TableCell align="center" style={{ width: 500 }}>Libellé</TableCell>
                  <TableCell align="center" style={{ width: 500 }}>Réponse</TableCell>
                  <TableCell align="center" style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center" style={{ width: 500 }}> <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 500 }}> <TextField
                      value={q.reponse}
                      onChange={(e) => handleChangeQuestion(e, "reponse", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponse", q.id)}
                      onBlur={(e) => handleBlur(e, "reponse", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    {/* <TableCell align="center" style={{ width: 100 }}> <TextField
                  type="number"
                    value={q.niveau}
                    onChange={ (e)=>handleChangeQuestion(e,"niveau",q.id)}
                    onKeyDown={ (e)=>handleKeyDown(e,"niveau",q.id)}
                    onBlur={ (e)=>handleBlur(e,"niveau",q.id)}
                    variant="outlined"
                    size="small"
                  /></TableCell> */}


                    <TableCell align="center" style={{ width: 50 }}>
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}
                {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)
      } else if (numJeu.includes("2 - ")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader aria-label="customized table">
              <TableHead>
                <TableRow >

                  <TableCell align="center" style={{ width: 500 }}>Libellé</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Gauche 1</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Gauche 2</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Droite 1</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Droite 2</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Fausse 1</TableCell>
                  <TableCell align="center" style={{ width: 400 }}>Réponse Fausse 2</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Niveau</TableCell>

                  <TableCell align="center" style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center" style={{ width: 500 }}> <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 400 }}> <TextField
                      value={q.reponseGauche1}
                      onChange={(e) => handleChangeQuestion(e, "reponseGauche1", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseGauche1", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseGauche1", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 400 }}> <TextField
                      value={q.reponseGauche2}
                      onChange={(e) => handleChangeQuestion(e, "reponseGauche2", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseGauche2", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseGauche2", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 400 }}> <TextField
                      value={q.reponseDroite1}
                      onChange={(e) => handleChangeQuestion(e, "reponseDroite1", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseDroite1", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseDroite1", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 400 }}> <TextField
                      value={q.reponseDroite2}
                      onChange={(e) => handleChangeQuestion(e, "reponseDroite2", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseDroite2", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseDroite2", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 400 }}> <TextField
                      value={q.reponseFausse1}
                      onChange={(e) => handleChangeQuestion(e, "reponseFausse1", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseFausse1", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseFausse1", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 400 }}> <TextField
                      value={q.reponseFausse2}
                      onChange={(e) => handleChangeQuestion(e, "reponseFausse2", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponseFausse2", q.id)}
                      onBlur={(e) => handleBlur(e, "reponseFausse2", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 100 }}> <TextField
                      type="number"
                      value={q.niveau}
                      onChange={(e) => handleChangeQuestion(e, "niveau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "niveau", q.id)}
                      onBlur={(e) => handleBlur(e, "niveau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" style={{ width: 50 }}>
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}

                {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)
      } else if (numJeu.includes("3 - ")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader aria-label="customized table">
              <TableHead>
                <TableRow >
                  <TableCell align="center" style={{ width: 600 }}>Libellé</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Réponse</TableCell>
                  <TableCell align="center" style={{ width: 100 }}>Niveau</TableCell>
                  <TableCell align="center" style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center"> <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > <TextField
                      value={q.reponse}
                      onChange={(e) => handleChangeQuestion(e, "reponse", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "reponse", q.id)}
                      onBlur={(e) => handleBlur(e, "reponse", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > <TextField
                      type="number"
                      value={q.niveau}
                      onChange={(e) => handleChangeQuestion(e, "niveau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "niveau", q.id)}
                      onBlur={(e) => handleBlur(e, "niveau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" >
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}

                {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)

      }else if (numJeu.includes("4 - ") || numJeu.includes("5 - ")) {
        return (
          <TableContainer component={Paper} style={{ maxHeight: 600 }} >
            <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow >
                  <TableCell align="center" style={{ width: 80 }}>ID Question</TableCell>
                  <TableCell align="center" style={{ width: 150 }}>Type</TableCell>

                  <TableCell align="center" style={{ width: 550 }} >Libellé</TableCell>
                  <TableCell align="center"  style={{ width: 350 }}>Data 1 </TableCell>
                  <TableCell align="center"style={{ width: 350 }} >Data 2 </TableCell>

                  <TableCell align="center" style={{ width: 80 }}>Niveau</TableCell>
                  <TableCell align="center"style={{ width: 50 }}>Actif</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {localQuestions.map((q) => (
                  <TableRow key={q.id} style={{ height: 10 }}>
                    <TableCell align="center" >
                     <TextField
                      type="number"
                      value={q.idQuestion}
                      onChange={(e) => handleChangeQuestion(e, "idQuestion", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "idQuestion", q.id)}
                      onBlur={(e) => handleBlur(e, "idQuestion", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > 
                    <Select
                      value={q.typeQuestion?.replace("PhraseTrou","Phrase à trou")}
                      onChange={(e) => handleChangeQuestion(e, "typeQuestion", q.id)}
                      onBlur={(e) => handleBlur(e, "typeQuestion", q.id)}
                      variant="outlined"
                      size="small"
                    >
                      {["QCM","Association","Phrase à trou"].map(c => (
                        <MenuItem key={c} value={c} style={{ paddingTop: 8, paddingBottom: 8 }}>{c}</MenuItem>
                      ))}
                    </Select>
                    </TableCell> 
         {/*  <TextField
                      value={q.typeQuestion}
                      onChange={(e) => handleChangeQuestion(e, "typeQuestion", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "typeQuestion", q.id)}
                      onBlur={(e) => handleBlur(e, "typeQuestion", q.id)}
                      variant="outlined"
                      size="small"
                    />*/}
                    <TableCell align="center"  > <TextField
                      value={q.libelle}
                      onChange={(e) => handleChangeQuestion(e, "libelle", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "libelle", q.id)}
                      onBlur={(e) => handleBlur(e, "libelle", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" > <TextField
                      value={q.data1}
                      onChange={(e) => handleChangeQuestion(e, "data1", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "data1", q.id)}
                      onBlur={(e) => handleBlur(e, "data1", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"  > <TextField
                      value={q.data2}
                      onChange={(e) => handleChangeQuestion(e, "data2", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "data2", q.id)}
                      onBlur={(e) => handleBlur(e, "data2", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center"> <TextField
                      type="number"
                      value={q.niveau}
                      onChange={(e) => handleChangeQuestion(e, "niveau", q.id)}
                      onKeyDown={(e) => handleKeyDown(e, "niveau", q.id)}
                      onBlur={(e) => handleBlur(e, "niveau", q.id)}
                      variant="outlined"
                      size="small"
                    /></TableCell>
                    <TableCell align="center" >
                      {/* <FormControlLabel
                    control={ */}
                      <Checkbox
                        onClick={(e) => (handleClicDelete(e, q))}
                        checked={q.actif == "OUI"}
                        sx={{
                          color: green[600],
                          '&.Mui-checked': {
                            color: green[600],
                          },
                        }}
                      />
                      {/*  }
     
                  /> */}

                      {/* <IconButton aria-label="delete">
                      <DeleteIcon color="primary" onClick={(e)=>{
                        handleClicDelete(q)
                      }}/>
                    </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}

                 {renderNewQuestion()}
              </TableBody>
            </Table>
          </TableContainer>)

      }
    }
    return null

  }

  const renderNewQuestion = () => {

    var disabled = !newQuestion || !newQuestion.libelle || newQuestion.libelle.length === 0  /* || !newQuestion.niveau */

    if (numJeu.includes("1 -")) {
      return (
        /*  <TableContainer component={Paper}>
           <Table  aria-label="customized table">
             
             <TableBody> */
        <TableRow key={"NEW QUESTION"}>
          {/* <TableCell align="center"></TableCell> */}
          <TableCell align="center" style={{ width: 500 }}> <TextField
            label="Libellé"
            value={newQuestion != null ? newQuestion.libelle : ''}
            onChange={(e) => handleChangeNewQuestion(e, "libelle")}
            // onKeyDown={ (e)=>handleKeyDown(e,"nom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"nom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 500 }}> <TextField
            label="Réponse"
            value={newQuestion != null ? newQuestion.reponse : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponse")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          {/* <TableCell align="center" style={{ width: 100 }}> <TextField
                type="number"
                  value={newQuestion!=null? newQuestion.niveau : ''}
                  onChange={ (e)=>handleChangeNewQuestion(e,"niveau")}
                  // onKeyDown={ (e)=>handleKeyDown(e,"email",u.id)}
                  // onBlur={ (e)=>handleBlur(e,"email",u.id)}
                  variant="outlined"
                  label="Niveau"
                  size="small"
                /></TableCell> */}

          <TableCell align="center" style={{ width: 50 }}>
            <IconButton aria-label="ajouter" disabled={disabled}>
              <AddIcon
                color={disabled ? "default" : "secondary"}
                //  || !newUser.nom || newUser.nom.length === 0

                onClick={(e) => {
                  handleClicNewQuestion()
                  // handleClicDelete(u)
                  // handleBlur(e,"actif",u.id)
                }} />
            </IconButton>
          </TableCell>
        </TableRow>
        /*   </TableBody>
        </Table>
      </TableContainer> */
      )
    } else if (numJeu.includes("2 - ")) {
      return (
        /*   <TableContainer component={Paper}>
            <Table  aria-label="customized table">
              
              <TableBody> */
        <TableRow key={"NEW QUESTION"}>
          {/* <TableCell align="center"></TableCell> */}
          <TableCell align="center" style={{ width: 500 }}> <TextField
            label="Libellé"
            value={newQuestion != null ? newQuestion.libelle : ''}
            onChange={(e) => handleChangeNewQuestion(e, "libelle")}
            // onKeyDown={ (e)=>handleKeyDown(e,"nom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"nom",u.id)}  
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 400 }}> <TextField
            label="Réponse Gauche 1"
            value={newQuestion != null ? newQuestion.reponseGauche1 : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponseGauche1")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 400 }}> <TextField
            label="Réponse Gauche 2"
            value={newQuestion != null ? newQuestion.reponseGauche2 : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponseGauche2")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 400 }}> <TextField
            label="Réponse Droite 1"
            value={newQuestion != null ? newQuestion.reponseDroite1 : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponseDroite1")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 400 }}> <TextField
            label="Réponse Droite 2"
            value={newQuestion != null ? newQuestion.reponseDroite2 : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponseDroite2")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 400 }}> <TextField
            label="Réponse Fausse 1"
            value={newQuestion != null ? newQuestion.reponseFausse1 : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponseFausse1")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 400 }}> <TextField
            label="Réponse Fausse 2"
            value={newQuestion != null ? newQuestion.reponseFausse2 : ''}
            onChange={(e) => handleChangeNewQuestion(e, "reponseFausse2")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>
          <TableCell align="center" style={{ width: 100 }}> <TextField
            label="Niveau"
            value={newQuestion != null ? newQuestion.niveau : ''}
            onChange={(e) => handleChangeNewQuestion(e, "niveau")}
            // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
            // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
            variant="outlined"
            size="small"
          /></TableCell>

          {/* <TableCell align="center" style={{ width: 100 }}> <TextField
                type="number"
                  value={newQuestion!=null? newQuestion.niveau : ''}
                  onChange={ (e)=>handleChangeNewQuestion(e,"niveau")}
                  // onKeyDown={ (e)=>handleKeyDown(e,"email",u.id)}
                  // onBlur={ (e)=>handleBlur(e,"email",u.id)}
                  variant="outlined"
                  label="Niveau"
                  size="small"
                /></TableCell> */}

          <TableCell align="center" style={{ width: 50 }}>
            <IconButton aria-label="ajouter" disabled={disabled}>
              <AddIcon
                color={disabled ? "default" : "secondary"}
                //  || !newUser.nom || newUser.nom.length === 0

                onClick={(e) => {
                  handleClicNewQuestion()
                  // handleClicDelete(u)
                  // handleBlur(e,"actif",u.id)
                }} />
            </IconButton>
          </TableCell>
        </TableRow>
          /*   </TableBody>
          </Table>
        </TableContainer> */)
    } else if (numJeu.includes("3 - ")) {
      return (<TableRow key={"NEW QUESTION"}>
        <TableCell align="center" > <TextField
          label="Libellé"
          value={newQuestion != null ? newQuestion.libelle : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelle")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Réponse"
          value={newQuestion != null ? newQuestion.reponse : ''}
          onChange={(e) => handleChangeNewQuestion(e, "reponse")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          label="Niveau"
          value={newQuestion != null ? newQuestion.niveau : ''}
          onChange={(e) => handleChangeNewQuestion(e, "niveau")}
          // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
          // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center">
          <IconButton aria-label="ajouter" disabled={disabled}>
            <AddIcon
              color={disabled ? "default" : "secondary"}
              //  || !newUser.nom || newUser.nom.length === 0

              onClick={(e) => {
                handleClicNewQuestion()

              }} />
          </IconButton>
        </TableCell>
      </TableRow>)
    }else if (numJeu.includes("4 - ") || numJeu.includes("5 - ")) {
      return (<TableRow key={"NEW QUESTION"}>
        <TableCell align="center" >
          <TextField
          type="number"
          label="ID"

          value={newQuestion != null ? newQuestion.idQuestion : ''}
          onChange={(e) => handleChangeNewQuestion(e, "idQuestion")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > 
        <Select
          label="Type"

          value={newQuestion != null ? newQuestion.typeQuestion : ''}
          onChange={(e) => handleChangeNewQuestion(e, "typeQuestion")}
          variant="outlined"
          size="small"
        >
          {["QCM","Association","Phrase à trou"].map(c => (
            <MenuItem key={c} value={c} style={{ paddingTop: 8, paddingBottom: 8 }}>{c}</MenuItem>
          ))}
        </Select>
        </TableCell> 

        <TableCell align="center"><TextField
          label="Libellé"
          value={newQuestion != null ? newQuestion.libelle : ''}
          onChange={(e) => handleChangeNewQuestion(e, "libelle")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center"><TextField
          label="Data 1"
          value={newQuestion != null ? newQuestion.data1 : ''}
          onChange={(e) => handleChangeNewQuestion(e, "data1")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center"><TextField
          label="Data 2"
          value={newQuestion != null ? newQuestion.data2 : ''}
          onChange={(e) => handleChangeNewQuestion(e, "data2")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" > <TextField
          type="number"
          label="Niveau"

          value={newQuestion != null ? newQuestion.niveau : ''}
          onChange={(e) => handleChangeNewQuestion(e, "niveau")}

          variant="outlined"
          size="small"
        /></TableCell>
        <TableCell align="center" >
          <IconButton aria-label="ajouter" disabled={disabled}>
            <AddIcon
              color={disabled ? "default" : "secondary"}
              //  || !newUser.nom || newUser.nom.length === 0

              onClick={(e) => {
                handleClicNewQuestion()

              }} />
          </IconButton>
        </TableCell>
      </TableRow>)
    }

  }


  const handleClosePopup = async (choix) => {

    switch (choix) {
      case 'Supprimer Question':
        // setActualiser(true)
        await BackendAPI.updateQuestion("NON", "actif", popupQuestion.id, numJeu)


        setPopupQuestion(null)
        setQuestions(null)
    }

    setPopupText(null)
  }


  const handleClicNumJeu = async (event) => {
    event.preventDefault()
    setNumJeu(event.target.value)
    const questions = await BackendAPI.getQuestions(event.target.value.split(" - ")[0])
    setQuestions(questions)
  }


  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div
        className="body-admin"
      >
        <Typography variant="h1" color="primary">Gestion des questions</Typography>
        <Divider />

        {/* <Button
          variant="contained"
          style={{padding:4}}
          className=""
          color={"primary"}
          // disabled={!actualiser}
        >
          {"Actualiser"}
        </Button> */}

        <div style={{ display: "flex", flex: 1, justifyContent: "center", alignItems: "center", flexDirection: "row" }}>
          <Typography variant="h5" color="primary" style={{ width: 200 }}>Choix du jeu</Typography>
          <Select
            value={numJeu}
            variant="outlined"
            onChange={(e) => { handleClicNumJeu(e) }}
          >
            {["1 - Cupcakes Battle", "2 - Find the Balance", "3 - What a bun!","4 - Crazy Coo-Quiz Accounting","5 - Crazy Coo-Quiz Financial Analysis"].map(c => (
              <MenuItem key={c} value={c} style={{ paddingTop: 8, paddingBottom: 8 }}>{c}</MenuItem>
            ))}
          </Select>
        </div>



        {
          popupText != null ?
            <Popup open={true} text={popupText} reponse={"Supprimer Question"} handleClose={handleClosePopup} ></Popup>
            :
            null
        }
        <div style={{ margin: 10 }}  >
          <br></br>
          {/*           <Typography variant="h5" color="primary">Liste de questions : {numJeu.split(" - ")[1]}</Typography>
 */}
          {renderQuestions()}

          {/*  <br></br> */}
          {/*  <Typography variant="h5" color="primary">Créer une nouvelle question</Typography>

          {renderNewQuestion()} */}
          {/* {newUser.nom} {newUser.prenom} {newUser.email} ({newUser.campus} - {newUser.groupe}) */}
        </div>



        {/* </div> */}

      </div></div>
  );
}

export default AdminQuestions;

